import { AxiosResponse } from "axios";
import { TravelGuideInputs } from "../pages/page-components/TravelGuide/TabAddTravelGuide";
import httpUtil from "../utils/http.util";
import { ITravelGuide } from "../helpers/types/global";

class TravelGuideService {
  async storeTravelGuide(data: TravelGuideInputs) {
    return await httpUtil.post("/travelGuide/create", data);
  }

  async getAllTravelGuides(query: string) {
    return await httpUtil.get(`/travelGuide/getAll${query}`);
  }

  getTravelGuideDetail(
    param: string
  ): Promise<AxiosResponse<{ data: ITravelGuide }>> {
    return httpUtil.get(`/travelGuide/${param}`);
  }

  updateTravelGuide(id: string, data: TravelGuideInputs) {
    return httpUtil.patch("/travelGuide/update", id, data);
  }
}

export default new TravelGuideService();
